import { Note, Progression } from '@tonaljs/tonal';

import React from 'react';
import _ from 'lodash';

const cleanNote = (note) => {
  if(note.endsWith("#b"))
  {
    return Note.simplify(note.substring(0, note.length-2));
  }
  return note;
  //return Note.simplify(note);
}

const Tone = ({ children, ...props }) => {
  let regex = /((^|\s)(?<romantonic>I{1,3}|IV|VI{0,2}){1}([#b])?){1}([\s,.!?]|$)/g;
  let contentOrg = '';
  React.Children.forEach(children, (child) => {
    if (typeof child === 'string') {
      contentOrg += child;
    }
  });
  var content = '';
  if (contentOrg !== '') {
    var keytonic = props.t;

    const matches = [...contentOrg.matchAll(regex)];
    var romanTones = _.map(matches, function (item, idx) {
      return item[3]+(item[4]?item[4]:"");
    });
    let tones = Progression.fromRomanNumerals(keytonic, romanTones);
    content = contentOrg.replace(regex, (match, p1, p2, p3, p4, p5) => p2 +cleanNote(tones.shift()) + p5); // p5=separator
  }
  return (
    <>{content}</>
  )
}

export default Tone;